/**
 * ✅ Migrated to authStore_v1 - 2026-01-07
 */

import { Outlet, Navigate } from 'react-router-dom';
import { useIsAuthenticated } from '@/stores/authStore_v1';

interface PublicRouteProps {
  redirectTo?: string; // Currently unused but kept for future use
  children?: React.ReactNode;
}

export function PublicRoute({ 
  redirectTo: _redirectTo = '/app/dashboard',
  children 
}: PublicRouteProps) {
  const isAuthenticated = useIsAuthenticated();

  // Redirect to home if already authenticated
  // Note: Loading is handled by App.tsx AuthHandler
  if (isAuthenticated) {
    console.log('🔓 PublicRoute: User already authenticated, redirecting to', _redirectTo);
    return <Navigate to={_redirectTo} replace />;
  }

  // Render children or outlet
  return children ? <>{children}</> : <Outlet />;
}

export default PublicRoute;
